"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommonConstants {
}
CommonConstants.SYSTEM_NAME_FMK_GUI = "fmk-gui";
CommonConstants.REPLACEMENT_DOCTOR_ORG = 990027;
CommonConstants.TOKEN_SHOW_REIMBURSEMENTS_FOR_LMO = "show-reimbursements-for-lmo";
CommonConstants.TOKEN_OPEN_REIMBURSEMENT_DIALOG = "open-reimbursement-dialog";
CommonConstants.TOKEN_DRUG_CHANGED = "drug-changed";
CommonConstants.TOKEN_POST_APPLICATION = "post-application";
CommonConstants.TOKEN_SHOW_REIMBURSEMENT_APP_SELECTOR = "show-reimb-app-selector";
CommonConstants.TOKEN_IS_APPLICATION_VALID = "check-application";
CommonConstants.TOKEN_IS_APPLICABLE_FOR_DRUG = "is-applicable-for-drug";
CommonConstants.TOKEN_SHOW_REIMBURSEMENT_PANEL = "show-reimbursement-panel";
CommonConstants.TOKEN_ENABLE_SINGLE_REIMBURSEMENT = "enable-single-reimbursement";
CommonConstants.TOKEN_ENABLE_RAISED_REIMBURSEMENT = "enable-raised-reimbursement";
CommonConstants.TOKEN_HAS_MUTATE_DRAFT_PERMISSION = "has-mutate-draft-permission";
CommonConstants.TOKEN_HAS_READ_DRAFT_PERMISSION = "has-mutate-read-permission";
CommonConstants.TOKEN_HAS_MUTATE_REIMBURSEMENT_PERMISSION = "has-mutate-reimbursement-permission";
CommonConstants.TOKEN_HAS_READ_REIMBURSEMENT_PERMISSION = "has-read-reimbursement-permission";
CommonConstants.X_SUPPORT_TAG_HEADER = "X-Support-Tag";
exports.default = CommonConstants;
//# sourceMappingURL=CommonConstants.js.map